import React from 'react'
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import NACell from '../Reusable/DataTable/NACell';
import TableActionButton from '../Reusable/TableActionButton';
import DataTable from '../Reusable/DataTable/UserDataTable';
import SwitchButton from '../Reusable/SwitchButton';

const UserList = (props: any) => {
  const { handleIsActive, handleIsSuperUser, handleIsStaff } = props


  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Full Name",
      accessorKey: "full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Username",
      accessorKey: "username",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "mobile_number",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      )
    },
    {
      header: "Staff",
      accessorKey: "is_staff",
      cell: ({ row, getValue }) => {
        return (
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            onChange={handleIsStaff}
            disabled={false}
          />
        );
      },
    },
    {
      header: "Superuser",
      accessorKey: "is_superuser",
      cell: ({ row, getValue }) => {
        return (
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            onChange={handleIsSuperUser}
            disabled={false}
          />
        );
      },
    }
  ];
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  if (userProfileType?.is_staff) {
    defaultColumns.push({
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },)
  }
  return (
    <DataTable
      url={APIS.USER}
      queryKey={"users"}
      columns={defaultColumns}
      addNewPagePath={userProfileType?.is_staff ? "/create-user" : ""}
      tableName={"Users"}
    />
  )
}

export default UserList